import { GridCellParams, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';
import { ECGLead } from 'types/enums';
import { ECGLeadType, ECGWaveFormResponseDto, PatientTableItem, StudyTableItem } from 'types/types';

const ECGFilteredData: Record<ECGLeadType, (data: ECGWaveFormResponseDto[]) => boolean> = {
  [ECGLead.I]: (data) => data.some((waveform) => waveform.ecgLead === ECGLead.I),
  [ECGLead.II]: (data) => data.some((waveform) => waveform.ecgLead === ECGLead.II),
  [ECGLead.III]: (data) => data.some((waveform) => waveform.ecgLead === ECGLead.III),
  [ECGLead.V1]: (data) => data.some((waveform) => waveform.ecgLead === ECGLead.V1),
  [ECGLead.V2]: (data) => data.some((waveform) => waveform.ecgLead === ECGLead.V2),
  [ECGLead.V3]: (data) => data.some((waveform) => waveform.ecgLead === ECGLead.V3),
  [ECGLead.V4]: (data) => data.some((waveform) => waveform.ecgLead === ECGLead.V4),
  [ECGLead.V5]: (data) => data.some((waveform) => waveform.ecgLead === ECGLead.V5),
  [ECGLead.V6]: (data) => data.some((waveform) => waveform.ecgLead === ECGLead.V6),
  [ECGLead.aVF]: (data) => data.some((waveform) => waveform.ecgLead === ECGLead.aVF),
  [ECGLead.aVL]: (data) => data.some((waveform) => waveform.ecgLead === ECGLead.aVL),
  [ECGLead.aVR]: (data) => data.some((waveform) => waveform.ecgLead === ECGLead.aVR),
};

const getFilterParams = () => ({
  getApplyFilterFn: (filterItem: GridFilterItem) => {
    if (!filterItem.field || !filterItem.operator) {
      return null;
    }

    return (params: GridCellParams<PatientTableItem | StudyTableItem, ECGWaveFormResponseDto[]>) => {
      if ('ecgLead' in params.row) {
        return params.row.ecgLead === filterItem.operator;
      }

      if (!('waveform' in params.row) || typeof params.row.waveform === 'string') {
        return false;
      }

      return ECGFilteredData[filterItem.operator](params.row.waveform);
    };
  },
});

export const getPatientECGFilters = (): GridFilterOperator[] => {
  return Object.values(ECGLead).map((value) => {
    return {
      label: value,
      value: value,
      ...getFilterParams(),
    };
  });
};
